export const multiAccount = {
  multi_account: {
    go_back: "Volver",
    current_account: "Cuenta actual",
    switch_account: "Cambiar de cuenta",
    add_account: "Añadir cuenta",
    remove_account: "Cerrar sesión en esta cuenta",
    logout_current: "Cerrar sesión en {{email}}",
    logout_all: "Cerrar sesión en todas las cuentas",
    already_signed_in: "{{email}} ya tiene la sesión iniciada.",
    logged_out: "Se cerró la sesión de {{email}} porque caducó.",
    impersonate_title: "¿Añadir otra cuenta?",
    impersonate_message:
      "Has iniciado sesión como {{email}}. La cuenta suplantada se añadirá junto a ella y podrás volver cuando quieras desde el menú de la cuenta.",
    impersonate_continue: "Continuar",
  },
};
